import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import NouriaLayout from './components/NouriaLayout';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
import Nouria from './pages/Nouria';
import NouriaSupport from './pages/NouriaSupport';
import NouriaPrivacy from './pages/NouriaPrivacy';

/* The Pantry Life chrome: dark header and footer around the trainer pages. */
function SiteLayout() {
  return (
    <div className="page-wrapper">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/support" element={<Support />} />
        </Route>

        {/* Nouria has its own light chrome; see components/NouriaLayout.js */}
        <Route path="/nouria" element={<NouriaLayout />}>
          <Route index element={<Nouria />} />
          <Route path="support" element={<NouriaSupport />} />
          <Route path="privacy" element={<NouriaPrivacy />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
